// extracted by mini-css-extract-plugin
module.exports = {"loading-spinner":"_3l0uH0h2EuRsVTa9vMtwNj"};